module.exports = __webpack_public_path__ + "static/media/meeting.8d9a6b57.jpg";